import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/banner-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { ArrowLeftCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

export const Banner = () => {
  const { t } = useTranslation();
  const currentLang = cookies.get("i18next") || "en";
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [t("Web Developer")];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  });

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };
  function onMouseOverStyle() {
    currentLang === "ar"
      ? (document.querySelector(".banner button svg").style.margin =
          "0 25px 0 0")
      : (document.querySelector(".banner button svg").style.margin =
          "0 0 0 25px");
  }
  function onMouseLeaveStyle() {
    currentLang === "ar"
      ? (document.querySelector(".banner button svg").style.margin =
          "0 10px 0 0")
      : (document.querySelector(".banner button svg").style.margin =
          "0 0 0 10px");
  }
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">
                    {t("Welcome to my Portfolio")}
                  </span>
                  <h1>
                    {t(`Hi! I'm Rawaa`)} <br></br>
                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Web Developer", "Web Designer"]'
                    >
                      <h2 className="wrap">{text}</h2>
                    </span>
                  </h1>

                  <button
                    onMouseOver={onMouseOverStyle}
                    onMouseLeave={onMouseLeaveStyle}
                  >
                    <a href="Rawaa Baessa CV.pdf" download className="download">
                      {t("Download My Cv")}{" "}
                      {currentLang === "ar" ? (
                        <ArrowLeftCircle size={25} />
                      ) : (
                        <ArrowRightCircle size={25} />
                      )}
                    </a>
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img src={headerImg} loading="lazy" alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
